import { render, staticRenderFns } from "./ItemGroupView.vue?vue&type=template&id=3f356400&scoped=true"
import script from "./ItemGroupView.vue?vue&type=script&lang=js"
export * from "./ItemGroupView.vue?vue&type=script&lang=js"
import style0 from "./ItemGroupView.vue?vue&type=style&index=0&id=3f356400&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f356400",
  null
  
)

export default component.exports